import AppHttpClient from '../api-manager/api/http-client';
import HttpPathsEnum from '../api-manager/api/http-paths.enum';
import { HttpRequest, RequestType } from '../api-manager/api/http-request';
import { GetCategoryResponseDto } from '../event/dto/responses/get-category.response.dto';
import { AddNewServiceCallRequestDto } from './dto/request/add-new-service-call.request.dto';
import { AddNewServiceCallResponseDto } from './dto/response/add-new-service-call.response.dto';
import { SupportSubCategoryResponseDto } from './dto/response/support-sub-category.response.dto';
import { UploadFilesServiceCallResponseDto } from './dto/response/upload-files-service-call.response.dto';
import { GetVisittEventsQueryDto } from './dto/queries/get-visitt-events.query.dto';
import { VisittEventByPaginationResponseDto } from './dto/response/visitt-event-by-pagination.response.dto';

const SUPPORT_PATH = HttpPathsEnum.USERS;

class SupportManagementApi {
  public async createNewServiceCall(data: AddNewServiceCallRequestDto) {
    const request: HttpRequest = {
      url: `${SUPPORT_PATH}/support`,
      method: RequestType.POST,
      data,
    };

    return await AppHttpClient.exec<
      AddNewServiceCallRequestDto,
      AddNewServiceCallResponseDto
    >(request, AddNewServiceCallResponseDto);
  }

  public async uploadServiceCallImage(data: any) {
    const request: HttpRequest = {
      url: `${SUPPORT_PATH}/support/upload-file`,
      method: RequestType.POST,
      data,
      headers: {
        'content-type': 'multipart/form-data',
      },
    };

    return await AppHttpClient.exec<any, UploadFilesServiceCallResponseDto>(
      request,
      UploadFilesServiceCallResponseDto
    );
  }

  public async getSupportCategories() {
    const request: HttpRequest = {
      url: `${SUPPORT_PATH}/support-category/all`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, GetCategoryResponseDto[]>(
      request,
      GetCategoryResponseDto,
      { addLanguage: true }
    );
  }

  public async getSupportSubCategoriesByCategoryId(category_id: number) {
    const request: HttpRequest = {
      url: `${SUPPORT_PATH}/support-sub-category/all/${category_id}`,
      method: RequestType.GET,
    };

    return await AppHttpClient.exec<any, SupportSubCategoryResponseDto[]>(
      request,
      SupportSubCategoryResponseDto
    );
  }

  public async getSupportEvents(query: GetVisittEventsQueryDto) {
    const request: HttpRequest = {
      url: `${SUPPORT_PATH}/support/visitt-events`,
      method: RequestType.GET,
      params: query,
    };

    return await AppHttpClient.exec<any, VisittEventByPaginationResponseDto>(
      request,
      VisittEventByPaginationResponseDto
    );
  }
}

export default new SupportManagementApi();
